var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Header'),_c('div',{staticClass:"container d-flex justify-content-center"},[_c('UserLogin')],1),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-center mt-5"},[_vm._v("Powered By "),_c('a',{attrs:{"target":"_blank","href":"https://chrilantech.com"}},[_vm._v("Chrilan Technology")])])
}]

export { render, staticRenderFns }